<template>
  <div v-if="showPicker" class="region-city-picker">
    <span class="region-city-picker__label">选择地区</span>
    <div class="region-city-picker__list">
      <span
        v-for="item in regionItems"
        :key="item.key"
        class="region-chip"
        :class="{ active: isItemActive(item) }"
        @click="handleItemClick(item)"
      >
        {{ item.label }}
      </span>
    </div>
  </div>
</template>

<script>
import {
  getCityOptionsForCurrent,
  getRegionBarMode,
  getRegionChangeDetail,
  getSelectedCityLabel,
  setRegionFromNavbar,
  setSelectedCity
} from '@/utils/region'
import { provinceNeedsCityPicker } from '@/utils/provinceCities'

export default {
  name: 'RegionCityPicker',
  data() {
    return {
      localCity: '',
      primary: '',
      barMode: 'hidden',
      cities: [],
      showPicker: false
    }
  },
  computed: {
    regionItems() {
      const items = [
        { key: 'nationwide', type: 'nationwide', label: '全国', value: '全国' }
      ]
      if (this.primary && this.primary !== '全国') {
        items.push({
          key: `region-${this.primary}`,
          type: 'region',
          label: this.formatRegionChipLabel(this.primary),
          value: this.primary
        })
      }
      if (this.barMode === 'cities') {
        this.cities.forEach((city) => {
          items.push({
            key: `city-${city}`,
            type: 'city',
            label: this.formatCityLabel(city),
            value: city
          })
        })
      }
      return items
    }
  },
  mounted() {
    this.syncFromStore()
    window.addEventListener('region-changed', this.syncFromStore)
  },
  beforeDestroy() {
    window.removeEventListener('region-changed', this.syncFromStore)
  },
  methods: {
    syncFromStore() {
      this.barMode = getRegionBarMode()
      this.showPicker = this.barMode !== 'hidden'
      if (!this.showPicker) {
        this.localCity = ''
        this.primary = ''
        this.cities = []
        return
      }
      const detail = getRegionChangeDetail()
      this.primary = detail.province || ''
      if (this.barMode === 'cities') {
        this.cities = getCityOptionsForCurrent()
        this.localCity = getSelectedCityLabel()
      } else {
        this.cities = []
        this.localCity = ''
      }
    },
    formatRegionChipLabel(name) {
      if (!name) return name
      if (provinceNeedsCityPicker(name) && name.endsWith('省')) {
        return name.slice(0, -1)
      }
      return name
    },
    formatCityLabel(name) {
      if (!name) return name
      if (name.includes('土家族苗族自治州')) {
        return name.split('土家族')[0]
      }
      if (name.endsWith('林区')) {
        return name.replace(/林区$/, '')
      }
      if (name.endsWith('市')) {
        return name.slice(0, -1)
      }
      return name
    },
    isItemActive(item) {
      const detail = getRegionChangeDetail()
      if (item.type === 'nationwide') {
        return detail.province === '全国'
      }
      if (item.type === 'region') {
        return detail.province === item.value
      }
      return (this.localCity || '') === item.value
    },
    handleItemClick(item) {
      if (item.type === 'nationwide' || item.type === 'region') {
        setRegionFromNavbar(item.value)
      } else {
        setSelectedCity(item.value)
      }
      this.syncFromStore()
    }
  }
}
</script>

<style lang="scss" scoped>
.region-city-picker {
  display: flex;
  align-items: flex-start;
  gap: 12px 16px;
  width: 100%;
  padding: 12px 16px;
  background: #fafafa;
  border-bottom: 1px solid #eef2f6;
  box-sizing: border-box;

  &__label {
    flex-shrink: 0;
    font-size: 14px;
    color: #999;
    line-height: 28px;
    white-space: nowrap;
  }

  &__list {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 16px;
  }
}

.region-chip {
  font-size: 14px;
  color: #333;
  line-height: 28px;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.2s ease, background 0.2s ease;

  &:hover {
    color: #0f6fe2;
  }

  &.active {
    padding: 0 10px;
    background: #0f6fe2;
    color: #fff;
    border-radius: 2px;
  }
}
</style>
